import { Button, Space, Typography } from 'antd';
import { GithubOutlined, LinkedinFilled, MailOutlined } from '@ant-design/icons';

const { Text } = Typography;

const HomeFooter = () => (
  <>
    <Space size="large" className="footer-links">
      <Button
        type="text"
        icon={<GithubOutlined />}
        href="https://github.com/your-handle"
        target="_blank"
        rel="noreferrer"
      >
        GitHub
      </Button>
      <Button
        type="text"
        icon={<LinkedinFilled />}
        href="https://linkedin.com/in/marcoscortorreal"
        target="_blank"
        rel="noreferrer"
      >
        LinkedIn
      </Button>
      <Button
        type="text"
        icon={<MailOutlined />}
        href="mailto:marcoscortorreal@gmail.com"
      >
        marcoscortorreal@gmail.com
      </Button>
    </Space>
    <Text type="secondary">
      Copyright {new Date().getFullYear()} Marcos Cortorreal
    </Text>
  </>
);

export default HomeFooter;
